import { FetchResult, withFetchErrorHandling } from "./resourceTypes";

/**
 * Base fetch wrapper that returns a FetchResult.
 * Captures errors to telemetry with rich context.
 *
 * @param url - The URL to fetch
 * @param init - Optional fetch init options
 * @returns FetchResult containing either the Response or an error
 */
export async function fetchResource(url: string, init?: RequestInit): Promise<FetchResult<Response>> {
  return withFetchErrorHandling(url, "fetchResource", (response) => Promise.resolve(response), init);
}
